import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Nisem verjel, da je lahko tako enostavno. Brez stresa, brez pogajanj, samo ponudbe sem primerjal.',
  name: 'Marko T.',
  vehicle: 'VW Golf 7',
  initials: 'MT'
}, {
  quote: 'Prodal sem avto v 8 dneh. Celoten postopek je bil profesionalen in transparenten.',
  name: 'Ana K.',
  vehicle: 'Audi A4',
  initials: 'AK'
}, {
  quote: 'Končno sem se znebil nadležnih klicev in pogajanj. Priporočam vsem, ki cenijo svoj čas.',
  name: 'Janez N.',
  vehicle: 'BMW 320d',
  initials: 'JN'
}];
const stats = [{
  number: '5+',
  label: 'let izkušenj'
}, {
  number: '5.000+',
  label: 'registriranih kupcev'
}, {
  number: '4.9/5',
  label: 'ocena strank'
}, {
  number: '1.500+',
  label: 'uspešnih prodaj'
}];
const partners = ['AutoTrader', 'CarGurus', 'Mobile.de', 'Avto.net', 'Bolha.com'];
export function SocialProof() {
  return <section className="py-16 md:py-24 bg-slate-50" data-id="element-312">
      <div className="container mx-auto px-4" data-id="element-313">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-314">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-315">
            Zakaj nam stranke zaupajo?
          </h2>

          {/* Stats Row */}

          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-lg shadow-sm" data-id="element-316">
            <div className="w-8 h-8 bg-blue-600 rounded flex items-center justify-center text-white font-bold text-sm" data-id="element-317">
              G
            </div>
            <div className="flex items-center gap-1" data-id="element-318">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-319" />)}
            </div>
            <span className="text-slate-900 font-semibold" data-id="element-320">4.6/5</span>
            
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-321">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-xl p-6 shadow-sm" data-id="element-322">
              <div className="flex gap-1 mb-4" data-id="element-323">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-324" />)}
              </div>
              <p className="text-slate-700 mb-4 leading-relaxed" data-id="element-325">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-3" data-id="element-326">
                <div className="w-10 h-10 bg-[#1EB6E8] rounded-full flex items-center justify-center text-white font-semibold" data-id="element-327">
                  {testimonial.initials}
                </div>
                <div data-id="element-328">
                  <div className="font-semibold text-slate-900" data-id="element-329">
                    {testimonial.name}
                  </div>
                  <div className="text-sm text-slate-600" data-id="element-330">
                    {testimonial.vehicle}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>

        
      </div>
    </section>;
}